var exports = {
  "O": "FavoritesGuildHeader.module__headerIconContainer___Rzd6ZH",
  "n": "FavoritesGuildHeader.module__headerIcon___Rzd6ZH",
};

module.exports = exports;
